import { ITranslations } from 'types/common';
import { PointsRequestsTableTransFields } from './types';
import en from 'translations/en/pointsRequestsTable.json';
import pl from 'translations/pl/pointsRequestsTable.json';
import sl from 'translations/sl/pointsRequestsTable.json';

export const pointsRequestsTableTranslations: ITranslations<PointsRequestsTableTransFields> = {
  name: 'pointsRequestsTable',
  en,
  pl,
  sl,
};
